import { Box, Collapse, Grid, Link, Tooltip, Typography, useTheme, makeStyles, Theme } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import React from "react";
import clsx from "clsx";
import { useHistory } from "react-router";
import ExpandCircleDown from "legacy-components/icons/ExpandCircleDown";

// Define styles using makeStyles hook
const useStyles = makeStyles((theme: Theme) => ({
  productStackCard: {
    backgroundColor: '#fff',
    borderTop: `1px solid ${theme.palette.primary.dark}`,
    padding: '1rem',
    position: "relative",
    minHeight: '115px',
    width: '100%',
    maxWidth: '100%',
    wordBreak: 'break-word',
    boxSizing: 'border-box',
  },
  expanded: {
    minHeight: 'unset',
  },
  expandIconContainer: {
    position: "absolute",
    bottom: "10px",
    right: "10px"
  },
  productDetailsLink: {
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: "36px",
    color: "#004F83"
  },
  collapsibleContent: {
    maxHeight: 'none',
    overflowY: 'visible',
    marginRight: '20px',
    marginTop: '0.5rem',
    transition: 'max-height 0.3s',
  },
  visibilityBadge: {
    color: "#0063A3",
    padding: "4px 8px",
    border: " 1px solid #0063A3",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "1px",
    position: "absolute",
    top: "10px",
    right: "10px"
  }
}));

export interface Product {
    id: string;
    name: string;
    displayName?: string;
    shortDescription?: string;
    longDescription?: string;
    created?: string;
    updated?: string;
    visibility?: string;
    isGuest?: boolean;
}
export const ProductStackCard: React.FC<Product> = ({
    id,
    displayName,
    name,
    shortDescription,
    longDescription,
    visibility,
    isGuest
  }) => {
    const theme = useTheme();
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(true);  
    return (
      <Grid container className={clsx('product-stack-card', classes.productStackCard, { [classes.expanded]: expanded && longDescription })} key={id}>
        {visibility && (
          <Box component="span" className={classes.visibilityBadge}>
            {visibility.toUpperCase()}
          </Box>
        )}
        <Grid item>
          <Box>
            <ProductDetailsLink id={id} formattedValue={name ?? displayName} isGuest={isGuest} />
          </Box>
          {shortDescription ? (
            <>
              {shortDescription}
              {longDescription && (
                <>
                  <Box className={classes.expandIconContainer}>
                    <ExpandCircleDown 
                      onClick={() => setExpanded(!expanded)} 
                      className={clsx(["product-collapse", { "product-expanded": expanded}])}/>
                  </Box>
                  <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <Box className={classes.collapsibleContent}>
                      {longDescription}
                    </Box>
                  </Collapse>
                </>
              )}
            </>
          ) : longDescription ? (
            <>
              <Box className={classes.expandIconContainer}>
                <ExpandCircleDown 
                  onClick={() => setExpanded(!expanded)} 
                  className={clsx(["product-collapse", { "product-expanded": expanded}])}/>
              </Box>
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Box className={classes.collapsibleContent}>
                  {longDescription}
                </Box>
              </Collapse>
            </>
          ) : null}
          {
            !longDescription && (

              <Tooltip title="No detailled description available" placement="left">
              <Box className={classes.expandIconContainer}>
                <ExpandCircleDown 
                  onClick={() => setExpanded(!expanded)} 
                  className={clsx(["product-collapse", { "product-disabled": true}])}/>
              </Box>

              </Tooltip>
            )
          }
        </Grid>
      </Grid>
    );
  };


export const Actions = (params: any) => {
    return <Delete />;
  };
  
  export const ProductDetailsLink = (params: any) => {
    const history = useHistory();
    const classes = useStyles();
    const onClick = () => {
      if(params.isGuest === true){
        history.push(`/guest/products/${params.id}`);
      }else{
        history.push(`/home/consumer/products/${params.id}`);
      }
    }
    return <Typography variant="body1">
      <Link className={`link ${classes.productDetailsLink}`} onClick={onClick} {...params}>{params.formattedValue}</Link>
    </Typography>;
  };